import {Component, Input, OnInit} from '@angular/core';
import {
  RoutesEnum,
  Currency,
  FinanceBalanceOverviewReport,
  defaultCurrency,
  RightsEnum,
  utils
} from '../../../global';
import { SharedModule } from '../../shared.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'slm-cash-flow-balance-overview',
    templateUrl: 'cash-flow-balance-overview.component.html',
    standalone: true,
    imports: [
      SharedModule,
      CommonModule
    ]
})
export class CashFlowBalanceOverviewComponent implements OnInit {
  public readonly routes = RoutesEnum;
  public readonly rights = RightsEnum;
  public readonly params = {completionDateFrom: null};
  @Input() public income: FinanceBalanceOverviewReport = null;
  @Input() public outgoing: FinanceBalanceOverviewReport = null;
  @Input() public currency: Currency = defaultCurrency;

  public ngOnInit() {
    const date = new Date();
    date.setMonth(0, 1);
    this.params.completionDateFrom = utils.dateToServerDate(date);
  }
}
